module.exports = __webpack_public_path__ + "8d40c4c4ebc7ec3b5842fcbdee116e14.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-star.png
// module id = 2348
// module chunks = 0